import * as React from "react";
import {
    Button,
    FormGroup,
    Grid,
    Switch,
    TextField,
    FormControlLabel, FormControl, InputLabel, Select, MenuItem
} from "@material-ui/core";
import {API} from "aws-amplify";
import JsonRenderComponent from "../../../../utils/JsonRenderComponent";
import {Alert} from "@material-ui/lab";
import {LoadingSpinner} from "../../../../utils/LoadingSpinner";
import {
    initiateProgramEnrollmentDefault,
    initiateProgramEnrollmentConcessionsDefault,
    IInitiateProgramEnrollmentRequest
} from "./request/InitiateProgramEnrollmentRequest";
import {
    Frequencies,
    Programs,
    ConcessionsReasons,
    ConcessionTypes,
    ConcessionCategories
} from "../../../../consts/PacMan";
import { AMAZON_ID } from "../../../../consts/Patterns";

interface IProps {
    data?: any
}

interface IState {
    errorMessage: string
    isJsonInput: boolean
    isLoading: boolean
    jsonInput: string
    request: IInitiateProgramEnrollmentRequest
    response: any
}

enum InputField {
    DRUG_ID,
    PERSON_ID,
    LEGACY_ADDRESS_ID,
    PROFILE_ID,
    CUSTOMER_ID,
    PROGRAM_NAME,
    SCHEDULE_FREQUENCY,
    INTERVAL_DAYS,
    CONCESSIONS_REASON,
    CONCESSION_TYPE,
    CONCESSION_CATEGORY,
    ORDER_ID,
    PURCHASE_ID
}

class InitiateProgramEnrollmentSection extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            errorMessage: '',
            isJsonInput: false,
            isLoading: false,
            jsonInput: initiateProgramEnrollmentDefault,
            request: {} as IInitiateProgramEnrollmentRequest,
            response: ''
        };

        this.toggleJsonInput = this.toggleJsonInput.bind(this);
        this.setRequest = this.setRequest.bind(this);
        this.handleValidation = this.handleValidation.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    private get isConcessions(): boolean {
        return this.state.request.programName === Programs.AP_CONCESSIONS;
    }

    public render() {
        return(
            <Grid
                container
                direction="column"
                justify="center"
                alignItems="center"
                spacing={3}
            >

                <Grid item xs={12}>
                    <Grid container spacing={3} justify="center">
                        <Grid item xs>
                            <Alert severity="info">
                                <p>
                                    To create the FireFly contract, please follow steps from our wiki page and toggle to json input instead of standard form &nbsp;
                                    <a href="https://w.amazon.com/bin/view/Pharmacy/Public/Teams/APAQ/Automation/TestTools/Portal/PacMan/"
                                       target="_blank"
                                       rel="noopener noreferrer">
                                        Wiki page
                                    </a>
                                    !
                                </p>
                            </Alert>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs>
                    <FormGroup>
                        <FormControlLabel control={ <Switch onChange={ this.toggleJsonInput }/> } label="Toggle Json Input" />
                    </FormGroup>
                </Grid>


                { !this.state.isJsonInput &&
                    <Grid
                        container
                        direction="column"
                        justify="center"
                        alignItems="center"
                        spacing={3}
                    >
                        <Grid item xs>
                            <FormControl>
                                <InputLabel>Program Name</InputLabel>
                                <Select
                                    value={this.state.request.programName}
                                    style={{width: 400}}
                                    onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.PROGRAM_NAME, event) }
                                >
                                    {Object.keys(Programs).map(program => (
                                        <MenuItem key={program} value={program}>
                                            <em>{program}</em>
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs>
                            <TextField
                                style={{width: 400}}
                                label="Drug Id (Required)"
                                variant="outlined"
                                value={ this.state.request.drugId || '' }
                                onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.DRUG_ID, event) }
                            />
                        </Grid>
                        <Grid item xs>
                            <TextField
                                style={{width: 400}}
                                label="Person Id (Required)"
                                variant="outlined"
                                value={ this.state.request.personId || '' }
                                onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.PERSON_ID, event) }
                            />
                        </Grid>
                        <Grid item xs>
                            <TextField
                                style={{width: 400}}
                                label="Legacy Address Id (Required)"
                                variant="outlined"
                                value={ this.state.request.legacyAddressId || '' }
                                onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.LEGACY_ADDRESS_ID, event) }
                            />
                        </Grid>
                        <Grid item xs>
                            <TextField
                                style={{width: 400}}
                                label="Profile Id (Required)"
                                variant="outlined"
                                value={ this.state.request.profileId || '' }
                                onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.PROFILE_ID, event) }
                            />
                        </Grid>
                        <Grid item xs>
                            <TextField
                                style={{width: 400}}
                                label="Customer Id (Required)"
                                variant="outlined"
                                value={ this.state.request.customerId || '' }
                                onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.CUSTOMER_ID, event) }
                            />
                        </Grid>

                        {/* Schedule fields — shown for non-concessions programs */}
                        {!this.isConcessions && <Grid item xs>
                            <FormControl>
                                <InputLabel>Schedule Frequency</InputLabel>
                                <Select
                                    value={this.state.request.scheduleFrequency || ''}
                                    style={{width: 400}}
                                    onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.SCHEDULE_FREQUENCY, event)}
                                >
                                    {Object.keys(Frequencies).map(frequency => (
                                        <MenuItem key={frequency} value={frequency}>
                                            <em>{frequency}</em>
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>}
                        {!this.isConcessions && this.state.request.scheduleFrequency !== Frequencies.ONE_TIME && <Grid item xs>
                            <TextField
                                style={{width: 400}}
                                type="number"
                                label="Interval Days"
                                variant="outlined"
                                value={ this.state.request.intervalDays || '' }
                                onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.INTERVAL_DAYS, event) }
                            />
                        </Grid>}

                        {/* Concessions fields — shown only for AP_CONCESSIONS */}
                        {this.isConcessions && <>
                            <Grid item xs>
                                <FormControl>
                                    <InputLabel>Concessions Reason (Required)</InputLabel>
                                    <Select
                                        value={this.state.request.concessionsReason || ''}
                                        style={{width: 400}}
                                        onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.CONCESSIONS_REASON, event)}
                                    >
                                        {Object.keys(ConcessionsReasons).map(reason => (
                                            <MenuItem key={reason} value={reason}>
                                                <em>{reason}</em>
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs>
                                <FormControl>
                                    <InputLabel>Concession Type (Required)</InputLabel>
                                    <Select
                                        value={(this.state.request.concessionsFeatures && this.state.request.concessionsFeatures.concessionType) || ''}
                                        style={{width: 400}}
                                        onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.CONCESSION_TYPE, event)}
                                    >
                                        {Object.keys(ConcessionTypes).map(type => (
                                            <MenuItem key={type} value={type}>
                                                <em>{type}</em>
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs>
                                <FormControl>
                                    <InputLabel>Concession Category (Required)</InputLabel>
                                    <Select
                                        value={(this.state.request.concessionsFeatures && this.state.request.concessionsFeatures.concessionCategory) || ''}
                                        style={{width: 400}}
                                        onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.CONCESSION_CATEGORY, event)}
                                    >
                                        {Object.keys(ConcessionCategories).map(category => (
                                            <MenuItem key={category} value={category}>
                                                <em>{category}</em>
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs>
                                <TextField
                                    style={{width: 400}}
                                    label="Order Id (Required)"
                                    variant="outlined"
                                    value={ (this.state.request.originalOrderContext && this.state.request.originalOrderContext.orderId) || '' }
                                    onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.ORDER_ID, event) }
                                />
                            </Grid>
                            <Grid item xs>
                                <TextField
                                    style={{width: 400}}
                                    label="Purchase Id (Required)"
                                    variant="outlined"
                                    value={ (this.state.request.originalOrderContext && this.state.request.originalOrderContext.purchaseId) || '' }
                                    onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.PURCHASE_ID, event) }
                                />
                            </Grid>
                        </>}
                    </Grid>
                }

                { this.state.isJsonInput &&
                    <Grid item xs>
                        <TextField
                            multiline
                            rows={ 8 }
                            label="Initiate Program Enrollment Request"
                            variant="filled"
                            value={ this.state.jsonInput }
                            onChange={ this.setRequest }
                            style={{ width: 800 }}
                        />
                    </Grid>
                }

                <Grid item xs>
                    <Button variant="outlined" color="default" onClick={ this.handleSubmit }>
                        Submit
                    </Button>
                </Grid>

                { this.state.isLoading && <LoadingSpinner/> }

                { this.state.errorMessage &&
                    <Alert variant="filled" severity="info">
                        Error encountered: { this.state.errorMessage }
                    </Alert>
                }

                { this.state.response &&
                    <div>
                        <br/>
                        <h4>Status</h4>
                        <p style={{
                            border: '3px solid lightgray',
                            padding: '5px',
                            whiteSpace: "pre-wrap",
                            wordBreak: "normal",
                            wordWrap: "break-word"
                        }}>
                            <JsonRenderComponent jsonObject={ this.state.response } printHtml={ false }/>
                        </p>
                    </div>
                }
            </Grid>
        );
    }

    private toggleJsonInput() {
        const nextIsJson = !this.state.isJsonInput;
        if (nextIsJson) {
            // Only overwrite jsonInput if the user hasn't edited it (still matches a default template)
            const isConcessions = this.state.request.programName === Programs.AP_CONCESSIONS;
            const jsonDefault = isConcessions
                ? initiateProgramEnrollmentConcessionsDefault
                : initiateProgramEnrollmentDefault;
            const isUnedited = this.state.jsonInput === initiateProgramEnrollmentDefault
                || this.state.jsonInput === initiateProgramEnrollmentConcessionsDefault;
            this.setState({
                isJsonInput: true,
                jsonInput: isUnedited ? jsonDefault : this.state.jsonInput,
            });
        } else {
            this.setState({ isJsonInput: false });
        }
    }

    private handleValidation(request: IInitiateProgramEnrollmentRequest): boolean {
        const errors: string[] = [];
        if (!request.personId) {
            errors.push('person id');
        } else if (!request.personId.match(AMAZON_ID)) {
            errors.push('valid person id');
        }
        if (!request.profileId) {
            errors.push('profile id');
        } else if (!request.profileId.match(AMAZON_ID)) {
            errors.push('valid profile id');
        }
        if (!request.customerId) {
            errors.push('customer id');
        } else if (!request.customerId.match("^A[A-Z0-9]*$")) {
            errors.push('valid customer id');
        }
        if (!request.legacyAddressId) {
            errors.push('legacy address id');
        } else if (!request.legacyAddressId.match("^[0-9]{12}$")) {
            errors.push('valid legacy address id');
        }
        if (!request.drugId) {
            errors.push('drug id');
        } else if (!request.drugId.match("^[A-Za-z0-9]{24}$")) {
            errors.push('valid drug id');
        }
        if (!request.programName) {
            errors.push('program name');
        }

        // Concessions-specific validation
        if (request.programName === Programs.AP_CONCESSIONS) {
            if (!request.concessionsReason) {
                errors.push('concessions reason');
            }
            if (!request.concessionsFeatures || !request.concessionsFeatures.concessionType) {
                errors.push('concession type');
            }
            if (!request.concessionsFeatures || !request.concessionsFeatures.concessionCategory) {
                errors.push('concession category');
            }
            if (!request.originalOrderContext || !request.originalOrderContext.orderId) {
                errors.push('order id');
            }
            if (!request.originalOrderContext || !request.originalOrderContext.purchaseId) {
                errors.push('purchase id');
            }
        } else {
            // Non-concessions validation
            if (request.scheduleFrequency !== Frequencies.ONE_TIME && !request.intervalDays) {
                errors.push('interval days (schedule frequency is not ONE_TIME)');
            }
        }

        if (errors.length > 0) {
            this.setState({ errorMessage: `Please provide: ${errors.join(', ')}` });
            return false;
        }
        return true;
    }

    private setRequestFields(field: InputField, event: React.ChangeEvent<HTMLTextAreaElement>) {
        const updatedRequest: IInitiateProgramEnrollmentRequest = { ...this.state.request };

        switch (field) {
            case InputField.DRUG_ID: {
                updatedRequest.drugId = event.target.value;
                break;
            }
            case InputField.PERSON_ID: {
                updatedRequest.personId = event.target.value;
                break;
            }
            case InputField.PROGRAM_NAME: {
                updatedRequest.programName = event.target.value;
                // Clear concessions fields when switching away from AP_CONCESSIONS
                if (event.target.value !== Programs.AP_CONCESSIONS) {
                    delete updatedRequest.concessionsReason;
                    delete updatedRequest.concessionsFeatures;
                    delete updatedRequest.originalOrderContext;
                } else {
                    // Clear schedule fields when switching to AP_CONCESSIONS
                    delete updatedRequest.scheduleFrequency;
                    delete updatedRequest.intervalDays;
                    // Initialize concessions sub-objects
                    updatedRequest.concessionsFeatures = { concessionType: '', concessionCategory: '' };
                    updatedRequest.originalOrderContext = { orderId: '', purchaseId: '' };
                }
                break;
            }
            case InputField.PROFILE_ID: {
                updatedRequest.profileId = event.target.value;
                break;
            }
            case InputField.LEGACY_ADDRESS_ID: {
                updatedRequest.legacyAddressId = event.target.value;
                break;
            }
            case InputField.CUSTOMER_ID: {
                updatedRequest.customerId = event.target.value;
                break;
            }
            case InputField.SCHEDULE_FREQUENCY: {
                updatedRequest.scheduleFrequency = event.target.value;
                break;
            }
            case InputField.INTERVAL_DAYS: {
                updatedRequest.intervalDays = Number(event.target.value);
                break;
            }
            case InputField.CONCESSIONS_REASON: {
                updatedRequest.concessionsReason = event.target.value;
                break;
            }
            case InputField.CONCESSION_TYPE: {
                updatedRequest.concessionsFeatures = {
                    ...(updatedRequest.concessionsFeatures || { concessionType: '', concessionCategory: '' }),
                    concessionType: event.target.value,
                };
                break;
            }
            case InputField.CONCESSION_CATEGORY: {
                updatedRequest.concessionsFeatures = {
                    ...(updatedRequest.concessionsFeatures || { concessionType: '', concessionCategory: '' }),
                    concessionCategory: event.target.value,
                };
                break;
            }
            case InputField.ORDER_ID: {
                updatedRequest.originalOrderContext = {
                    ...(updatedRequest.originalOrderContext || { orderId: '', purchaseId: '' }),
                    orderId: event.target.value,
                };
                break;
            }
            case InputField.PURCHASE_ID: {
                updatedRequest.originalOrderContext = {
                    ...(updatedRequest.originalOrderContext || { orderId: '', purchaseId: '' }),
                    purchaseId: event.target.value,
                };
                break;
            }
            default: {
                break;
            }
        }
        this.setState({ request: updatedRequest });
    }

    private setRequest(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({ jsonInput: event.target.value });
    }

    private handleSubmit() {
        this.setState({isLoading: true, errorMessage: '', response: ''});
        let body: IInitiateProgramEnrollmentRequest;

        if (this.state.isJsonInput) {
            try {
                body = JSON.parse(this.state.jsonInput);
            } catch (e) {
                this.setState({isLoading: false, errorMessage: `Invalid JSON: ${e instanceof Error ? e.message : String(e)}`});
                return;
            }
        } else {
            body = this.state.request;
        }

        if (this.handleValidation(body)) {
            const config = {
                body,
                headers: {}
            }
            this.callInitateEnrollment(config);
        } else {
            this.setState({isLoading: false});
        }
    }

    private callInitateEnrollment(config: any) {
        const apiName = 'ApaqPortalAPI';
        const path = '/pharmacy-customer/initiate-program-enrollment';

        console.log(config)
        API.post(apiName, path, config).then((enrollmentResponse: any) => {
            console.log(enrollmentResponse);
            this.setState({ response: enrollmentResponse, errorMessage: '', isLoading: false });
        }).catch((error: any) => {
            console.log(error);
            this.setState({
                response: '',
                errorMessage: error.response?.data?.message || error.message || 'An unknown error occurred',
                isLoading: false
            });
        });
    }
}

export default InitiateProgramEnrollmentSection;
